module.exports = __webpack_public_path__ + "~@/assets/img/2_copy.45cb1e84.png";